export const STAFF_CLEARANCE_LIST_QUERY_KEY = 'staff-clearance-list';
